const videoTriggers = document.querySelectorAll(".video img");

if(videoTriggers) {

    videoTriggers.forEach((item) => {
       const parent = item.parentElement;

        item.addEventListener("click", () => {
            parent.classList.add("video--play");
            parent.querySelector("video").play();
        })
   });
}